/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftStartMutationRequest, PostApiBarberShiftStartMutationResponse, PostApiBarberShiftStart400, PostApiBarberShiftStart401, PostApiBarberShiftStart403, PostApiBarberShiftStart404, PostApiBarberShiftStart500 } from "../entities/PostApiBarberShiftStart";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftStart } from "../api/postApiBarberShiftStart";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftStartMutationKey = () => [{ url: '/api/barber/shift/start' }] as const

export type PostApiBarberShiftStartMutationKey = ReturnType<typeof postApiBarberShiftStartMutationKey>

export function postApiBarberShiftStartMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBarberShiftStartMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftStartMutationKey()
        return mutationOptions<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, {data: PostApiBarberShiftStartMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiBarberShiftStart(data, config)
          },
        })

}

/**
 * @description Мастер начинает рабочую смену
 * @summary Начать смену
 * {@link /api/barber/shift/start}
 */
export function usePostApiBarberShiftStart<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, {data: PostApiBarberShiftStartMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBarberShiftStartMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftStartMutationKey()

          const baseOptions = postApiBarberShiftStartMutationOptions(config) as UseMutationOptions<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, {data: PostApiBarberShiftStartMutationRequest}, TContext>
          

          return useMutation<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, {data: PostApiBarberShiftStartMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftStartMutationResponse, ResponseErrorConfig<PostApiBarberShiftStart400 | PostApiBarberShiftStart401 | PostApiBarberShiftStart403 | PostApiBarberShiftStart404 | PostApiBarberShiftStart500>, {data: PostApiBarberShiftStartMutationRequest}, TContext>
      
}